
if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-services', {
        // built-in attributes
        title: 'Card Service',
        description: 'Custom Card Service',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            image: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                image,
                title,
            } = attributes;

            // custom functions

            function onSelectImage (image) {
                setAttributes({image: image.url});
            }


            function onTitleChange(title) {
                setAttributes({title: title});
            }


            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                    </PanelBody>
                </InspectorControls>
                ,
                <div className ="card service-card">
                    <div className ="card-img" data-background-image={ image }
                    style={ image ? { backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' , width: '100%'} : {} }
                    >
                    </div>
                    <div className ="card-body">
                        <div class="title-container">
                            <RichText 
                                key="editable" 
                                tagName="h6"
                                className="title"
                                placeholder="TITLE" 
                                value={ title }
                                onChange={ onTitleChange } />
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                image,
                title,
            } = attributes;

            return (
                <div className={ "card service-card"}>
                    <div className="card-img lozad cover-image" data-background-image={ image }>
                    </div>
                    <div className="card-body">
                        <div className="title-container">
                            <h6 className="title">
                                { title }
                            </h6>
                        </div>
                    </div>
                </div>
            );
        },
    });
}